module.exports = __webpack_public_path__ + "static/media/41.d5332d6a.JPG";